var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.honor},[_c('the-honor-tabs',{attrs:{"data":_vm.navData},on:{"change":_vm.handleChange}}),_vm._v(" "),_c('the-honor-list',{attrs:{"data":_vm.honorList}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }